import { REVOKE_PUB_NUB_AUTH_KEY } from '@graphql/operations/notifications/revokePubNubAuthKey';

export default async function revokePubNubAuthKey(apolloClient, authKey) {
  if (apolloClient && authKey) {
    return apolloClient.mutate({
      mutation: REVOKE_PUB_NUB_AUTH_KEY,
      variables: {
        authKey
      }
    });
  }
}
